import { Injectable } from '@angular/core';
import { encryptStorage } from 'src/utils/storage';

@Injectable({
  providedIn: 'root',
})
export class CacheService {
  setItem(key: string, value: any) {
    encryptStorage.setItem(key, value);
  }

  getItem(key: string): any {
    return encryptStorage.getItem(key);
  }

  cleanLocalStorage(): void {
    localStorage.clear();
  }

  cleanSessionStorage(): void {
    sessionStorage.clear();
  }
}
